export default __webpack_public_path__ + "static/media/appdynamics.02eb30a2.svg";